import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-toasts-header-be',
  templateUrl: './toasts-header-be-container.component.html',
  host: { 'class': 'toast-header-be-container position-fixed bottom-0 end-0 p-3', 'style': 'z-index: 1200' }
})
export class ToastsHeaderBEContainer {
  @Input()
  type: any
  @Input()
  title: any
  @Input()
  text: any
  @Input()
  percentage: any
  @Output() toastClosed = new EventEmitter<void>(); // Emissor para notificar o fechamento

  constructor() { }

  onToastHidden() {
    this.toastClosed.emit();
  }
}
